/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Table_Row_CountInputs */

const en_table_row_count = /** @type {(inputs: Table_Row_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} row(s)`)
};

const pt_br2_table_row_count = /** @type {(inputs: Table_Row_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} linha(s)`)
};

/**
* | output |
* | --- |
* | "{count} row(s)" |
*
* @param {Table_Row_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_row_count = /** @type {((inputs: Table_Row_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Row_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_row_count(inputs)
	return pt_br2_table_row_count(inputs)
});